import {
  Globe,
  Phone,
  Cpu,
  Shield,
  Target,
  Zap,
  CheckCircle,
} from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import StructuredData from "./StructuredData";

const Servicios = () => {
  <StructuredData type="servicios" />;
  const { language, translations } = useLanguage();
  const servicios = translations[language].servicios;
  const services = [
    {
      icon: <Globe size={40} />,
      title: servicios.servicios[0].title,
      description: servicios.servicios[0].description,
      features: servicios.servicios[0].features,
    },
    {
      icon: <Phone size={40} />,
      title: servicios.servicios[1].title,
      description: servicios.servicios[1].description,
      features: servicios.servicios[1].features,
    },
    {
      icon: <Cpu size={40} />,
      title: servicios.servicios[2].title,
      description: servicios.servicios[2].description,
      features: servicios.servicios[2].features,
    },
    {
      icon: <Shield size={40} />,
      title: servicios.servicios[3].title,
      description: servicios.servicios[3].description,
      features: servicios.servicios[3].features,
    },
    {
      icon: <Target size={40} />,
      title: servicios.servicios[4].title,
      description: servicios.servicios[4].description,
      features: servicios.servicios[4].features,
    },
    {
      icon: <Zap size={40} />,
      title: servicios.servicios[5].title,
      description: servicios.servicios[5].description,
      features: servicios.servicios[5].features,
    },
  ];

  return (
    <section id="servicios" className="py-20 bg-gray-50 dark:bg-[#343b4b]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 text-gray-900 dark:text-white">
            {servicios.titulos.nuestrosServicios}
          </h2>
          <div className="w-24 h-1 bg-[#12A9B0] mx-auto mb-8"></div>
          <p className="text-xl max-w-3xl mx-auto text-gray-600 dark:text-gray-400">
            {servicios.textos.descripcion}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:transform hover:-translate-y-2 bg-white text-gray-600  dark:text-gray-400 dark:bg-gradient-to-b dark:from-gray-800 dark:to-gray-900"
            >
              <div className="text-[#12A9B0] mb-4">{service.icon}</div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">
                {service.title}
              </h3>
              <p className="mb-4 text-gray-600 dark:text-gray-400">
                {service.description}
              </p>
              <ul className="space-y-2 text-sm">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2">
                    <CheckCircle
                      size={16}
                      className="text-[#12A9B0] flex-shrink-0"
                    />
                    <span className="text-gray-600 dark:text-gray-400">
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() =>
              document
                .getElementById("contacto")
                .scrollIntoView({ behavior: "smooth" })
            }
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-[#12A9B0] to-[#0e8d92] text-white rounded-lg font-semibold hover:shadow-xl transform hover:scale-105 transition-all duration-300"
          >
            {servicios.titulos.solicitarCotizacion}
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Servicios;
